import React, { useState, useRef, useCallback, useEffect } from 'react'

import Layout from '../../Layout';
import { Breadcrumb, Tabs, TabsProps } from 'antd';
import BreadcrumbBlock from '../../components/BreadcrumbBlock/BreadcrumbBlock';
import { Link, useNavigate, useParams } from 'react-router-dom';
import './styles.scss'
import Overview from './components/Overview';
import VehicleInformation from './components/VehicleInformation';
import InvoiceHistory from './components/InvoiceHistory';
import UpdateHistory from './components/UpdateHistory';
import InteractionHistory from './components/InteractionHistory';
import { mixGetV3, mixGetV2 } from '../../services/mixin'

// import './stylesv2.scss'
import Infomation from './components/Infomation';
import InfomationLeft from './components/InfomationLeft';

const CustomerInforNew = () => {
  const navigate = useNavigate()
  const [stData, setStData] = useState({} as any);
  const isFetchingDetail = useRef(false);
  const { id } = useParams();
  const getDetail = useCallback(async (id: string) => {
    if (isFetchingDetail.current) return;
    isFetchingDetail.current = true;
    try {
      const searchParams = new URLSearchParams(window.location.search);
      const idSync = searchParams.get('id_sync') || '';
      const res = await mixGetV2(`/api/v1/be/warehouses_elastic/detail/${id}?id_sync=${idSync}`);
      if (res.data) {
        let total_order_amount = 0;
        let total_service_amount = 0;

        if (!res.data.vehicle_owner_total_sale) {
          res.data.vehicle_owner_total_sale = []
        }
        if (!res.data.vehicle_owner_total_service) {
          res.data.vehicle_owner_total_service = []
        }

        res.data.vehicle_owner_total_sale.map((val: any, index: any) => {
          total_order_amount += Number(val.trans_total_amount)
          res.data.vehicle_owner_total_sale[index].id = index + 1
        })
        res.data.vehicle_owner_total_service.map((val: any, index: any) => {
          total_service_amount += Number(val.repair_total_amount || 0)
          res.data.vehicle_owner_total_service[index].id = index + 1
        })
        const xequantam = [] as any
        const xequantam0 = [] as any
        res.data.vehicle_interest_history.sort((a: any, b: any) => new Date(b.interaction_date).getTime() - new Date(a.interaction_date).getTime());
        res.data.vehicle_interest_history.map((val: any) => {
          if (!xequantam0.some((item: any) => item.interaction_vehicle_name === (val.interaction_vehicle_name || 'Chưa biết'))) {
            xequantam0.push({
              brand: val.interaction_brand_name || 'Khác',
              interaction_branch_name: val.interaction_branch_name,
              interaction_color_name: val.interaction_color_name,
              interaction_date: val.interaction_date,
              interaction_details: val.interaction_details,
              interaction_employee_name: val.interaction_employee_name,
              interaction_id: val.interaction_id,
              interaction_made_year: val.interaction_made_year,
              interaction_route_name: val.interaction_route_name,
              interaction_vehicle_name: val.interaction_vehicle_name || 'Chưa biết',
              interaction_vehicle_status: val.interaction_vehicle_status
            });
          }
          xequantam.push(
            {
              brand: val.interaction_brand_name || 'Khác',
              interaction_branch_name: val.interaction_branch_name,
              interaction_color_name: val.interaction_color_name,
              interaction_date: val.interaction_date,
              interaction_details: val.interaction_details,
              interaction_employee_name: val.interaction_employee_name,
              interaction_id: val.interaction_id,
              interaction_made_year: val.interaction_made_year,
              interaction_route_name: val.interaction_route_name,
              interaction_vehicle_name: val.interaction_vehicle_name || 'Chưa biết',
              interaction_vehicle_status: val.interaction_vehicle_status
            }
          )
          // Sort xequantam by interaction_date descending
        })
        res.data.vehicle_owner.map((val: any, index: any) => {
          if (res.data.vehicle_owner[index].own_vehicle_brand === null || res.data.vehicle_owner[index].own_vehicle_brand === '') {
            res.data.vehicle_owner[index].own_vehicle_brand = 'Khác'
          }
        })
        const xesohuu = res.data.vehicle_owner.filter((val: any) => val.ownership_type === 'Sở hữu')
        const xesudung = res.data.vehicle_owner.filter((val: any) => val.ownership_type === 'Sử dụng')
        setStData((prev: any) => ({
          ...prev,
          ...res.data,
          total_order_amount,
          total_service_amount,
          xequantam,
          xequantam0,
          xequantam_show: '',
          chitiethoadon: [],
          chitietdichvu: [],
          xesohuu,
          xesudung,
          xesohuu_show: {},
          xesudung_show: {},
        }));
      } else {
        // navigate('/customer/pooling-data/customer-list');
      }
    } finally {
      isFetchingDetail.current = false;
    }
  }, []);

  useEffect(() => {
    if (id) {
      getDetail(id);
    }
  }, [id, getDetail]);

  const [isTab, setIsTab] = useState<number>(1)

  // tab
  const onChange = (key: string) => {
    setIsTab(Number(key));
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: <span className='custom-page-css font-light text-lg'>Tổng quan</span>,
      children: <Overview stData={stData} />,
    },
    {
      key: '2',
      label: <span className='custom-page-css font-light text-lg'>Thông tin xe</span>,
      children: <VehicleInformation stData={stData} stChange={(data) => {
        setStData((prev: any) => ({
          ...prev,
          ...data
        }))
      }} />,
    },
    {
      key: '3',
      label: <span className='custom-page-css font-light text-lg'>Lịch sử hóa đơn</span>,
      children: <InvoiceHistory stData={stData} stChange={(data) => {
        setStData((prev: any) => ({
          ...prev,
          ...data
        }))
      }} />,
    },
    {
      key: '4',
      label: <span className='custom-page-css font-light text-lg'>Lịch sử tương tác</span>,
      children: <InteractionHistory stData={stData} stChange={(data) => {
        setStData((prev: any) => ({
          ...prev,
          ...data
        }))
      }} />,
    },
    {
      key: '5',
      label: <span className='custom-page-css font-light text-lg'>Lịch sử cập nhật</span>,
      children: <UpdateHistory />,
    },
  ];

  return (
    <Layout>
      <BreadcrumbBlock
        items={[
          { title: <Link to="/">THACO AUTO CRM</Link>, },
          { title: <Link to="/customer/pooling-data">Khách hàng</Link>, },
          { title: <Link to="/customer/list">Danh sách khách hàng</Link>, },
          { title: 'Thông tin khách hàng', },
        ]}
        title='Thông tin khách hàng'
        backLink='/customer/list'
        className="gutter-block-end"
      />
      <div className="custom-page-css w-full flex flex-column gap-2">
        <div className={isTab !== 1 ? '' : 'hidden '} >
          <Infomation stData={stData} />
        </div>
        <div className="custom-page-css w-full h-full flex gap-2">
          <div className={isTab == 1 ? 'custom-page-css h-full w-1-4 shrink-0 transition overflow-y-scroll' : 'hidden '} >
            <InfomationLeft stData={stData} />
          </div>
          <div className="custom-page-css w-full h-full">
            <Tabs
              defaultActiveKey="1"
              items={items}
              onChange={onChange}
            />
          </div>
        </div>

      </div>
    </Layout>

  );
};
export default CustomerInforNew
